import { InputRule } from 'prosemirror-inputrules';
import { MarkType } from 'prosemirror-model';

export function markdownEmRule(markType: MarkType) {
  return new InputRule(/_(\w(?:.*\w)?)_/g, (state, match, start, end) => {
    return state.tr
      .insertText(match[1] + ' ', start, end)
      .addMark(start, start + match[1].length, markType.create());
  });
}
